<template>
  <v-container class="pt-0 pr-0">
    <v-toolbar flat>
      <v-spacer/>
      <bank-account-create-dialog>
        <template v-slot:activator="{ on }">
          <v-btn
            rounded
            outlined
            color="primary"
            v-on="on"
          >
            <v-icon>add</v-icon>
            Add Bank Account
          </v-btn>
        </template>
      </bank-account-create-dialog>
    </v-toolbar>
    <v-divider class="my-3"/>

    <base-stripe-table
      ref="externalAccountTable"
      :headers="headers"
      :fetch-action="'listExternalAccounts'"
      :fetch-query="{ object: 'bank_account', id: getSessionAccount }"
      :items-getter="'getExternalAccounts'"
      :pagination-getter="'getExternalAccountPagination'"
      :show-expand="true"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <template v-for="item in items">
            <tr
              :key="`${item.id}`"
            >
              <td @click="toggleExpand(item.id)">
                <v-icon v-if="expandedMap[item.id]">
                  keyboard_arrow_down
                </v-icon>
                <v-icon v-if="!expandedMap[item.id]">
                  keyboard_arrow_up
                </v-icon>
              </td>
              <td>
                {{ item.object }} - **** {{ item.last4 }}
                <v-chip small>
                  {{ item.currency.toUpperCase() }}
                </v-chip>
              </td>
              <td class="text-right">
                <v-chip
                  v-if="item.default_for_currency"
                  color="info"
                  small
                >
                  {{ item.currency.toUpperCase() }} DEFAULT
                </v-chip>
                <v-menu
                  v-if="!item.default_for_currency"
                  left
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item
                      @click="setCurrencyDefault(item.id)"
                    >
                      <v-list-item-action>
                        <v-icon>stars</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        Set as {{ item.currency.toUpperCase() }} default
                      </v-list-item-content>
                    </v-list-item>

                    <external-account-delete-dialog
                      :id="item.id"
                      @action="onDelete"
                    >
                      <template v-slot:activator="{ on }">
                        <v-list-item
                          v-on="on"
                          @click.stop=""
                        >
                          <v-list-item-action>
                            <v-icon class="red--text">
                              delete
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-content class="red--text">
                            Delete
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </external-account-delete-dialog>
                  </v-list>
                </v-menu>
              </td>
            </tr>
            <tr v-if="expandedMap[item.id]">
              <td/>
              <td>
                <info-list
                  :list="infoList(item)"
                />
              </td>
              <td/>
            </tr>
          </template>
        </tbody>
      </template>
    </base-stripe-table>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { get } from 'lodash'
import BankAccountCreateDialog from "./BankAccountCreateDialog"
import BaseStripeTable from '@/components/Common/BaseStripeTable.vue'
import InfoList from '@/components/Common/InfoList.vue'
import ExternalAccountDeleteDialog
  from '@/components/ExternalAccount/ExternalAccountDeleteDialog.vue'
import { getBankAccountToken } from "../../services/stripe.service"

export default {
  components: {
    BankAccountCreateDialog,
    BaseStripeTable,
    InfoList,
    ExternalAccountDeleteDialog,
  },
  data() {
    return {
      isLoading: false,
      expandedMap: {},
      headers: [
        {
          text: 'Bank Account',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Actions',
          align: 'right',
          sortable: false,
        },
      ]
    }
  },
  computed: {
    ...mapGetters([ 'getSessionAccount' ]),
  },
  methods: {
    ...mapActions([ 'updateExternalAccount' ]),
    toggleExpand(id) {
      const clone = { ...this.expandedMap }

      clone[ id ] = !clone[ id ]

      this.expandedMap = clone
    },
    async onDelete() {
      this.$refs.externalAccountTable.fetchData()
    },
    async setCurrencyDefault(externalId) {
      const payload = {
        id: externalId,
        default_for_currency: true,
      }

      await this.updateExternalAccount(payload)

      this.$refs.externalAccountTable.fetchData()
    },
    infoList(item) {
      return [
        {
          label: 'ID',
          value: get(item, 'id')
        },
        {
          label: 'Type',
          value: get(item, 'object')
        },
        {
          label: 'Account holder',
          value: get(item, 'account_holder_name')
        },
        {
          label: 'Bank',
          value: get(item, 'bank_name')
        },
        {
          label: 'Origin (Country)',
          value: get(item, 'country')
        },
      ]
    }
  }
}
</script>
